import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Service from './pages/Service';
import Orders from './pages/Orders';
import Produtos from './pages/Products';
import SugestaoCompra from './pages/Sugestao';
import Estoque from './pages/Estoque';
import Desempenhos from './pages/Desempenhos';
import RelatorioPesquisas from './pages/RelatorioPesquisas';
import Users from './pages/Users';
import ClientMessages from './pages/ClientMessages';
import SupplierList from './pages/Supplier';
import SupplierForm from './pages/Supplier_Form';
import UserForm from './pages/User_Form';
import Config from './pages/Config';
import Horario from './pages/Horario';
import Pdv from './pages/Pdv';
import Delivery from './pages/Delivery';
import Help from './pages/Help';
import Logout from './pages/Logout';
import Login from './pages/Login';
import CategoryImages from './pages/CategoryImages';
import Categories from './pages/Categories';
import StoreMovimentsPage from './pages/StoreMovimentsPage';
import CookieConsent from "./components/CookieConsent";
import CheckoutTest_MP from "./pages/CheckoutTest_MP";
import WebHooks_MP from "./pages/WebHooks_MP";
import MPPayments from "./pages/MPPayments.js";
import MPCredenciais from "./pages/MPCredenciais.js";
import NotFound from './pages/NotFound';
import Revenues from './pages/Revenues';
import Expenses from './pages/Expenses';

const AppLayout = () => {
  return (
    <>
      <Header />
      <div style={{ display: 'flex', height: '100vh' }}>
        <div
          style={{
            flex: 1,
            padding: '0 0 0 10px',
          }}
        >
          <Routes>
            <Route path="/" element={<Service />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/produtos" element={<Produtos />} />
            <Route path="/sugestao" element={<SugestaoCompra />} />
            <Route path="/estoque" element={<Estoque />} />
            <Route path="/storemoviments" element={<StoreMovimentsPage />} />
            <Route path="/Desempenhos" element={<Desempenhos />} />
            <Route path="/pesquisas" element={<RelatorioPesquisas />} />
            <Route path="/users" element={<Users />} />
            <Route path="/crm" element={<ClientMessages />} />
            <Route path="/supplier" element={<SupplierList />} />
            <Route path="/supplier_form" element={<SupplierForm />} />
            <Route path="/User_Form" element={<UserForm />} />
            <Route path="/config" element={<Config />} />
            <Route path="/horario" element={<Horario />} />
            <Route path="/pdv" element={<Pdv />} />
            <Route path="/delivery" element={<Delivery />} />
            <Route path="/help" element={<Help />} />
            <Route path="/categoryimages" element={<CategoryImages />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/checkout-mercadopago" element={<CheckoutTest_MP />} />
            <Route path="/webhooks-mp" element={<WebHooks_MP />} />
            <Route path="/mppayments" element={<MPPayments />} />
            <Route path="/mpcredenciais" element={<MPCredenciais />} />
            <Route path="/revenues" element={<Revenues />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
      {/* Modal de consentimento de cookies */}
      <CookieConsent />
    </>
  );
};

const App = () => {
  const location = useLocation();

  const isAuthenticated = !!sessionStorage.getItem('token');

  // Rota de logout
  if (location.pathname === '/logout') {
    return <Logout />;
  }

  // Se no autenticado, redireciona para login
  if (!isAuthenticated && location.pathname !== '/login') {
    return <Navigate to="/login" />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/*" element={<AppLayout />} />
    </Routes>
  );
};

const AppWithRouter = () => (
  <Router>
    <App />
  </Router>
);

export default AppWithRouter;
